import { render, staticRenderFns } from "./SubscribeCurations.vue?vue&type=template&id=8270a720&scoped=true&"
import script from "./SubscribeCurations.vue?vue&type=script&lang=js&"
export * from "./SubscribeCurations.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeCurations.vue?vue&type=style&index=0&id=8270a720&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8270a720",
  null
  
)

export default component.exports